var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:_vm.classes},[_c('svg',{attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"20"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }